import React from 'react'
import { useField, FieldHookConfig } from 'formik'

import StatInput, { StatInputProps } from '@/components/ui/inputs/StatInput'

type StatFieldProps = FieldHookConfig<string> & StatInputProps

const MemoizedStatInput = React.memo(StatInput)

export default function StatField(props: StatFieldProps) {
  const [field] = useField<string>(props)

  return (
    <MemoizedStatInput
      {...props}
      onBlur={field.onBlur}
      onChange={field.onChange}
      value={field.value}
    />
  )
}